// extracted by mini-css-extract-plugin
export default {"main":"galerij_main__do436","grid":"galerij_grid__woODw"};